<template>
  <div>
    <div 
      class="drawer-overlay" 
      :class="{ 'is-visible': visible }"
    >
      <div class="drawer-wrapper">
        <div class="drawer-header">
          <span class="drawer-title">已过期的保单险种</span>
          <span class="drawer-close" @click="handleClose">&times;</span>
        </div>
        <div class="drawer-body">
          <div v-if="policies && policies.length > 0" class="policy-table-wrapper">
            <vxe-table
              :data="policies"
              :column-config="{ resizable: true }"
              :row-config="{ isHover: true, height: 40 }"
              :header-cell-config="{ height: 40 }"
              border
              show-overflow="title"
              size="small"
            >
              <vxe-column type="seq" width="60" title="序号" align="center" fixed="left" />
              <vxe-column field="insuranceCompany" title="保险公司" min-width="120" align="center" />
              <vxe-column field="insuranceType" title="险种类型" min-width="120" align="center" />
              <vxe-column field="insuranceName" title="险种名称" min-width="150" align="center" />
              <vxe-column field="policyNo" title="保单号" min-width="150" align="center" />
              <vxe-column field="effectiveDate" title="生效日期" min-width="180" align="center" />
              <vxe-column field="costPrice" title="成本价" min-width="100" align="center" fixed="right" />
            </vxe-table>
          </div>
          
          <div v-else class="empty-tip">
            暂无历史保单数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryPolicyDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 112px 0 0 236px;
  box-sizing: border-box;
  pointer-events: none;
  transition: background-color 0.3s ease;
}

.drawer-overlay.is-visible {
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

.drawer-wrapper {
  width: 60%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.drawer-overlay.is-visible .drawer-wrapper {
  transform: translateX(0);
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 0 24px;
  background-color: #F2F3F5;
  border-bottom: 1px solid #e8e8e8;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
}

.drawer-close {
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.drawer-close:hover {
  color: #333;
}

.drawer-body {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  box-sizing: border-box;
}

.policy-table-wrapper {
  width: 100%;
}

.policy-table-wrapper :deep(.vxe-table) {
  border-radius: 4px;
  width: 100%;
}

.empty-tip {
  text-align: center;
  padding: 48px 0;
  color: #8D8E99;
  font-size: 14px;
}
</style>